const {
  CLEAR_LANDMARK_LIST,
  CREATE_LANDMARK,
  CREATE_LANDMARK_FAILED,
  CREATE_LANDMARK_SUCCESS,
  DELETE_LANDMARK,
  DELETE_LANDMARK_FAILED,
  DELETE_LANDMARK_SUCCESS,
  GET_LANDMARK_DETAILS,
  GET_LANDMARK_DETAILS_FAILED,
  GET_LANDMARK_DETAILS_SUCCESS,
  GET_LANDMARK_LIST,
  GET_LANDMARK_LIST_FAILED,
  GET_LANDMARK_LIST_SUCCESS,
  UPDATE_LANDMARK,
  UPDATE_LANDMARK_FAILED,
  UPDATE_LANDMARK_SUCCESS,
} = require('./actionTypes');

const initialState = {
  isLoadingLandmarkList: false,
  isLoadingLandmarkDetails: false,
  isLoadingCreateLandmark: false,
  isLoadingUpdateLandmark: false,
  isLoadingDeleteLandmark: false,
  landmarkOptions: [],
  landmarkDetails: {},
};

const landmark = (state = initialState, action) => {
  switch (action.type) {
    case GET_LANDMARK_LIST:
      return {
        ...state,
        isLoadingLandmarkList: true,
        landmarkOptions: [],
      };

    case GET_LANDMARK_DETAILS:
      return {
        ...state,
        isLoadingLandmarkDetails: true,
        landmarkDetails: {},
      };

    case CREATE_LANDMARK:
      return {
        ...state,
        isLoadingCreateLandmark: true,
      };

    case UPDATE_LANDMARK:
      return {
        ...state,
        isLoadingUpdateLandmark: true,
      };

    case DELETE_LANDMARK:
      return {
        ...state,
        isLoadingDeleteLandmark: true,
      };

    case GET_LANDMARK_LIST_SUCCESS:
      return {
        ...state,
        landmarkOptions: action.payload.landmarkOptions,
        isLoadingLandmarkList: false,
      };

    case GET_LANDMARK_DETAILS_SUCCESS:
      return {
        ...state,
        landmarkDetails: action.payload,
        isLoadingLandmarkDetails: false,
      };

    case CREATE_LANDMARK_SUCCESS:
      return {
        ...state,
        isLoadingCreateLandmark: false,
      };

    case UPDATE_LANDMARK_SUCCESS:
      return {
        ...state,
        isLoadingUpdateLandmark: false,
      };

    case DELETE_LANDMARK_SUCCESS:
      return {
        ...state,
        isLoadingDeleteLandmark: false,
      };

    case GET_LANDMARK_LIST_FAILED:
    case GET_LANDMARK_DETAILS_FAILED:
    case CREATE_LANDMARK_FAILED:
    case UPDATE_LANDMARK_FAILED:
    case DELETE_LANDMARK_FAILED:
      return {
        ...state,
        isLoadingLandmarkList: false,
        isLoadingLandmarkDetails: false,
        isLoadingCreateLandmark: false,
        isLoadingUpdateLandmark: false,
        isLoadingDeleteLandmark: false,
      };
    case CLEAR_LANDMARK_LIST:
      return {
        ...state,
        landmarkOptions: [],
        landmarkDetails: {},
        isLoadingLandmarkList: false,
        isLoadingLandmarkDetails: false,
        isLoadingCreateLandmark: false,
        isLoadingUpdateLandmark: false,
        isLoadingDeleteLandmark: false,
      };

    default:
      return state;
  }
};

export default landmark;
